import React, { memo } from "react";

const OtpInput = memo(({ value, index, onChange, onBackspace }) => {
  return (
    <input
      id={`otp-input-${index}`}
      type="text"
      value={value}
      maxLength={1}
      className="lg:w-12 lg:h-12 sm:w-8 sm:h-8 border border-gray-300 rounded-3xl text-center lg:text-lg focus:outline-none focus:ring focus:ring-orange-500 focus:border-orange-500 focus:text-black"
      onChange={(e) => onChange(e.target.value, index)}
      onKeyDown={(e) => {
        if (e.key === "Backspace") onBackspace(index);
      }}
    />
  );
});
OtpInput.displayName = "OtpInput";
export default OtpInput;
